import { IconButton } from '@talos/kyoko';
import styled from 'styled-components';

export const MakeDefaultMarketAccountButton = styled(IconButton)``;
